import { cn } from '@/shared/lib/utils'

interface BrandMarkProps {
  tone?: 'light' | 'dark'
  showWordmark?: boolean
  className?: string
  markClassName?: string
}

export function BrandMark({
  tone = 'light',
  showWordmark = true,
  className,
  markClassName,
}: BrandMarkProps) {
  const src = tone === 'dark' ? '/logo-icon-white.png' : '/logo-icon.png'

  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <img
        src={src}
        alt={showWordmark ? '' : 'PSN Fintech'}
        width={32}
        height={32}
        className={cn('h-8 w-8 shrink-0 object-contain', markClassName)}
      />
      {showWordmark && (
        <span className="flex items-baseline gap-1 leading-none">
          <span className="text-base font-extrabold tracking-tight">PSN</span>
          <span className="text-base font-medium tracking-tight">Connectors</span>
        </span>
      )}
    </span>
  )
}
